import CSS from './intro-unit.module.css'

export const IntroUnit = ({ children, overlapHero }) => {
    return (
        <section className={`${CSS.layout} ${overlapHero && CSS.overlap}`}>
            <span className={CSS.color}/>
            <span className={CSS.color}/>

            { children }
        </section>
    )
}

export const IntroUnitTitle = ({ children }) => {
    return (
        <div className={`${CSS.titleBox} bg-theme`}>
            { children }
        </div>
    )
}

export const IntroUnitBody = ({ children }) => {
    return (
        <div className={`${CSS.bodyBox} formatted`}>
            { children }
        </div>
    )
}